/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import { scrollIntoViewEffect } from "@components/utils/scroll.utils";
import { useEffect } from "react";

// HTML5 id attributes can contain any characters except whitespace.
// Previous regex only matched ids starting with a letter ([a-zA-Z]) and
// containing word characters/hyphens, which excluded numeric/dotted ids
// used on legal pages (e.g. "#1.7.1").
const hashRegEx = /^#[^\s]+$/;
const cleanHash = (hash?: string | null): string => {
	if (!hash || typeof hash !== "string" || !hashRegEx.test(hash)) return "";
	return hash.substring(1);
};

export const useScrollClientHash = (): void => {
	useEffect(() => {
		// Scroll to hash fragment after component mounts
		const hash = window.location.hash;

		// check hash
		const id = cleanHash(hash);
		if (!id) return;

		// Use a small delay 500 to ensure DOM is fully rendered
		return scrollIntoViewEffect(id, 500);
	}, []);
};

export const useScrollToAnchorId = (needle?: string | null): void => {
	useEffect(() => {
		// No needle no scroll
		if (!needle) return;

		// Scroll to hash fragment after component mounts
		const hash = window.location.hash;

		// check hash and needle
		const id = cleanHash(hash);
		if (!id || id !== needle) return;

		// Use a small delay 250 to ensure DOM is fully rendered
		return scrollIntoViewEffect(id);
	}, [needle]);
};
